import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  districts: [],
  municipalities: [],
  wards: [],
  canteenTypes: [],
  canteens: [],
  selectedDistrict: "",
  selectedMunicipality: "",
  selectedWard: "",
  selectedCanteenType: "",
  loading: false,
  error: null,
};

const canteenSlice = createSlice({
  name: "canteen",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setDistricts: (state, action) => {
      state.districts = action.payload;
    },
    setMunicipalities: (state, action) => {
      state.municipalities = action.payload;
    },
    setWards: (state, action) => {
      state.wards = action.payload;
    },
    setCanteenTypes: (state, action) => {
      state.canteenTypes = action.payload;
    },
    setCanteens: (state, action) => {
      state.canteens = action.payload;
    },
    setSelectedDistrict: (state, action) => {
      state.selectedDistrict = action.payload;
    },
    setSelectedMunicipality: (state, action) => {
      state.selectedMunicipality = action.payload;
    },
    setSelectedWard: (state, action) => {
      state.selectedWard = action.payload;
    },
    setSelectedCanteenType: (state, action) => {
      state.selectedCanteenType = action.payload;
    },
    resetMunicipalityData: (state) => {
      state.selectedMunicipality = "";
      state.selectedWard = "";
      state.municipalities = [];
      state.wards = [];
      state.canteens = [];
      state.error = null;
    },
    resetWardData: (state) => {
      state.selectedWard = "";
      state.wards = [];
      state.canteens = [];
      state.error = null;
    },
  },
});

export const {
  setLoading,
  setError,
  setDistricts,
  setMunicipalities,
  setWards,
  setCanteenTypes,
  setCanteens,
  setSelectedDistrict,
  setSelectedMunicipality,
  setSelectedWard,
  setSelectedCanteenType,
  resetMunicipalityData,
  resetWardData,
} = canteenSlice.actions;

export default canteenSlice.reducer;

